// extracted by mini-css-extract-plugin
export default {"illustrationWrap":"QJNc2ST4DRC3B1QQSvxZ6A=="};